import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Message } from '../class/message';
import { ApiService } from './api.service';
import { CommonService } from './common.service';
import { ContractService } from './contract.service';

@Injectable({
  providedIn: 'root'
})
export class DowloadAppService {
  constructor(
    private apiService: ApiService,
    private toastr: ToastrService,
    private contractService: ContractService,
    private commonService: CommonService,
    public message: Message) {
  }
  isIOS(): boolean {
    return /iPhone|iPad|iPod/i.test(window.navigator.userAgent);
  }
}
